const enum SDCCheckboxSize {
  Default = 'default',
  Large = 'large',
}
export default SDCCheckboxSize;
